import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import "./csae.scss"
export default function Csae({ appLong }) {

    const author = "Marlin Brandin"
    const address = "Charlottenburger Ufer 4, 10029 Berlin, Germany"
    const app = appLong
    const email = "info@mbrandin.com"
    const [lang, setLand] = useState("en")

    return (
        <div className='privacy'>



            <h1>CSAE and Child Safety Standards for “myBOY - Gay Chat and Dating”</h1>
            <p>
                “myBOY - Gay Chat and Dating”, published by Nightlife Barcelona, is strictly intended for adults aged 18 and older. We do not allow children or minors under 18 to access or use the app.
                We maintain a zero-tolerance policy toward Child Sexual Abuse and Exploitation (CSAE). Any behavior, content, or activity involving minors or CSAE is strictly prohibited and will be acted upon immediately.
                To ensure compliance with Google’s Child Safety Standards and applicable laws, we enforce the following:
                Explicit prohibition of child sexual abuse and exploitation (CSAE)
                Removal of any content involving minors
                User reporting tools for inappropriate or harmful content
                Active moderation and immediate account termination for child-related violations
                Cooperation with relevant authorities in cases of suspected CSAE
                Age confirmation requirement for all new accounts to ensure an 18+ user base
                These CSAE and child safety standards apply to all users of “myBOY - Gay Chat and Dating”, operated by Nightlife Barcelona.
                This page was last updated on 24 November 2025.


            </p>


            <p>This Privacy Policy was last updated 24 of November 2025</p>




        </div>
    )
}
